import { Divider, Stack } from '@mui/material'
import React from 'react'

const Footer = () => {
  return (
    <> 
        <Divider sx={{marginTop:'15px'}} />
        <div style={{color:"gray", padding:'15px 0', textAlign:'center'}}>©2022 Phoebe Yu</div>
    </>
       
  )
}

export default Footer